var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('Bio'),_c('Projects',{on:{"scroll":function($event){return _vm.updateScroll()}}}),_c('Tooling'),(_vm.learn_visible)?_c('Learning',{on:{"mouse":_vm.updateLearn}}):_vm._e(),_c('Resume'),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }